(() => {
  const cartEl = document.querySelector('[data-bm-cart]');
  if (!cartEl) return;
  const params = new URLSearchParams(location.search);
  let intent = params.get('bm_discount');
  try { intent = intent || sessionStorage.getItem('bmDiscountIntent'); } catch (_) {}
  if (intent !== 'BASS10') return;
  const status = cartEl.querySelector('[data-discount-status]');
  const checkout = cartEl.querySelector('[name="checkout"]');
  const show = text => { status.hidden = false; status.textContent = text; };
  const root = cartEl.dataset.root || '/';
  const get = async (endpoint, options) => {
    const response = await fetch(root + endpoint, { credentials: 'same-origin', ...options });
    if (!response.ok) throw new Error('Could not reach checkout.');
    return response.json();
  };
  const cleanup = () => {
    try { sessionStorage.removeItem('bmDiscountIntent'); } catch (_) {}
    const url = new URL(location.href); url.searchParams.delete('bm_discount');
    history.replaceState({}, '', url);
  };
  const hasDiscount = cart => {
    const allocations = [...(cart.cart_level_discount_applications || []),
      ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(d => d.discount_application))];
    return allocations.some(d => d && String(d.title).toUpperCase() === 'BASS10');
  };
  const run = async () => {
    if (checkout) checkout.disabled = true;
    show('Checking your BASS10 code...');
    try {
      const cart = await get('cart.js');
      const hasFive = cart.items.some(item => item.handle === 'bassmasks-fishing-mask' && /^5\s+masks?$/i.test(item.variant_title || ''));
      if (!hasFive) { cleanup(); show('BASS10 is for the 5-mask pack. You can still check out below.'); return; }
      if (hasDiscount(cart)) { cleanup(); show('BASS10 is applied. Your total below includes the discount.'); return; }
      const existingCodes = (cart.discount_codes || []).filter(d => d.applicable !== false).map(d => d.code).filter(Boolean);
      const codes = [...new Set([...existingCodes, 'BASS10'])].join(',');
      const updated = await get('cart/update.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: codes}) });
      cleanup();
      if (!hasDiscount(updated)) { show('BASS10 could not be applied. You can try it again at checkout.'); return; }
      location.reload();
    } catch (_) {
      cleanup(); show('We could not check the code just now. Enter BASS10 at checkout.');
    } finally { if (checkout) checkout.disabled = false; }
  };
  run();
})();
